import FixedEmailBanner from './fixed-email/fixed-email-banner';
import NavDemoLink from './nav-demo-link/nav-demo-link';
import PPCRedirect from './ppc-redirect/ppc-redirect';

export default { FixedEmailBanner, NavDemoLink, PPCRedirect };
